import { AssembliesClient } from './assemblies';
import { CurrentUserClient } from './current-user';
import { IntegrationsClient } from './integrations';
import { MaterialUnitsClient } from './material-units';
import { MetadataClient } from './metadata';
import { OrganizationInvitesClient } from './organization-invites';
import { OrgMembersClient } from './organization-members';
import { OrganizationsClient } from './organizations';
import { ProductCatalogsClient } from './product-catalogs';
import { ProjectsClient } from './projects';
import { RfiDraftsClient } from './rfi-drafts';
import { TakeoffComponentClient } from './takeoff-component';
import { TakeoffItemTagsClient } from './takeoff-item-tags';
import { TakeoffsClient } from './takeoffs';
import { UploadsClient } from './uploads';
import { UserAgreementClient } from './user-agreement';

export type ApiProps = {
  baseUrl: string;
  documentSetId?: number | undefined;
  headers?: HeadersInit | undefined;
};

export class Api {
  public readonly documentSetId: number | undefined;
  public readonly takeoffs: TakeoffsClient;
  public readonly assemblies: AssembliesClient;
  public readonly integrations: IntegrationsClient;

  public readonly productCatalogs: ProductCatalogsClient;
  public readonly materialUnits: MaterialUnitsClient;
  public readonly uploads: UploadsClient;
  public readonly projects: ProjectsClient;
  public readonly currentUser: CurrentUserClient;
  public readonly organizations: OrganizationsClient;
  public readonly organizationInvites: OrganizationInvitesClient;
  public readonly orgMembers: OrgMembersClient;
  public readonly takeoffItemTags: TakeoffItemTagsClient;
  public readonly takeoffComponents: TakeoffComponentClient;
  public readonly userAgreement: UserAgreementClient;
  public readonly metadata: MetadataClient;
  public readonly rfiDrafts: RfiDraftsClient;
  constructor({ baseUrl, headers, documentSetId }: ApiProps) {
    this.documentSetId = documentSetId;
    this.metadata = new MetadataClient({
      baseUrl,
      headers,
    });

    this.takeoffs = new TakeoffsClient({
      documentSetId,
      baseUrl,
      headers,
    });

    this.assemblies = new AssembliesClient({
      baseUrl,
      headers,
    });

    this.integrations = new IntegrationsClient({
      baseUrl,
      headers,
    });

    this.productCatalogs = new ProductCatalogsClient({
      baseUrl,
      headers,
    });

    this.materialUnits = new MaterialUnitsClient({
      baseUrl,
      headers,
    });

    this.uploads = new UploadsClient({
      baseUrl,
      headers,
    });

    this.projects = new ProjectsClient({
      documentSetId,
      baseUrl,
      headers,
    });

    this.currentUser = new CurrentUserClient({
      baseUrl,
      headers,
    });

    this.organizations = new OrganizationsClient({
      baseUrl,
      headers,
    });

    this.organizationInvites = new OrganizationInvitesClient({
      baseUrl,
      headers,
    });

    this.orgMembers = new OrgMembersClient({
      baseUrl,
      headers,
    });

    this.takeoffItemTags = new TakeoffItemTagsClient({
      baseUrl,
      headers,
    });

    this.takeoffComponents = new TakeoffComponentClient({
      baseUrl,
      headers,
    });

    this.userAgreement = new UserAgreementClient({
      baseUrl,
      headers,
    });

    this.rfiDrafts = new RfiDraftsClient({
      baseUrl,
      headers,
    });
  }
}

// Type exports
export type { RequestOptions } from './client';
export type { UploadsResponse } from './uploads';
